
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ManualModel } from "../models";
import { capitalize } from "../filters/capitalize";

const mStore = namespace("manual");

@Component({
  filters: { capitalize },
})
export default class ManualFilter extends Vue {
  @Prop({ required: true })
  value!: ManualModel[];
  @Prop({ required: true })
  manuals!: ManualModel[];
  @Prop({ default: false })
  reload!: boolean;

  @mStore.Getter allTags!: string[];

  search = "";
  selected: string[] = [];
  @Watch("selected")
  filterManuals(tags: string[]): void {
    const search = this.search.toLowerCase();
    const filtered = this.manuals.filter((manual: ManualModel): boolean => {
      for (let tag of tags) {
        if (manual.tags == null || !manual.tags.includes(tag)) return false;
      }
      return (
        search === "" ||
        manual.name.toLowerCase().includes(search) ||
        manual.description.toLowerCase().includes(search) ||
        (manual.tags !== null &&
          manual.tags.some((tag: string) => tag.toLowerCase().includes(search)))
      );
    });
    this.$emit("input", filtered);
  }

  @Watch("search")
  onSearch(): void {
    this.filterManuals(this.selected);
  }

  @Watch("reload")
  onReload(val: boolean): void {
    if (!val) return;

    this.filterManuals(this.selected);
    this.$emit("update:reload", false);
  }
}
